export default "<app-pdv></app-pdv>";